<template>
  <div class="block mb-100px">
    <!-- 履歷填寫日 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>履歷填寫日</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0">
        <div class="form-input-group w-248px my-n2">
          <input type="text" v-model="dateOfWriteResume" disabled />
        </div>
      </div>
    </div>
    <!-- 上傳檔案 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>上傳檔案</h4>
        <div class="mt-10px h5 ink-02-medium--text">
          建議檔案格式：PDF <br />
          檔案大小限制：&lt; 1 MB
        </div>
      </div>
      <div class="flex-grow-1 flex-basis-0">
        <FileUploader></FileUploader>
      </div>
    </div>
    <!-- 面試日期 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>面試日期</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="請選擇年份"
          buttonWidth="200px"
          modalWidth="200px"
          :options="options.year"
          :selectedValue.sync="yearOfInterview"
        ></SimpleSelectWithSearchInput>
        <SimpleSelect
          class="mr-5"
          buttonPlaceholder="請選擇月份"
          buttonWidth="200px"
          modalWidth="200px"
          :options="options.month"
          :selectedValue.sync="monthOfInterview"
        ></SimpleSelect>
        <SimpleSelect
          class="mr-5"
          buttonPlaceholder="請選擇日期"
          buttonWidth="200px"
          modalWidth="200px"
          :options="options.date"
          :selectedValue.sync="dateOfInterview"
        ></SimpleSelect>
      </div>
    </div>
    <!-- 面試時間 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>面試時間</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <TimeSelector
          :hour.sync="hourOfInterview"
          :minute.sync="minuteOfIntervew"
        ></TimeSelector>
      </div>
    </div>
    <!-- 面試階段 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>面試階段</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="請選擇階段"
          buttonWidth="248px"
          modalWidth="248px"
          :options="['初試-視訊', '複試']"
          :selectedValue.sync="phrase"
        ></SimpleSelectWithSearchInput>
      </div>
    </div>
    <!-- 職位類別 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>職位類別</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="請選擇類別"
          buttonWidth="248px"
          modalWidth="248px"
          :options="['人力資源類', '工程師類']"
          :selectedValue.sync="categoryOfPosition"
        ></SimpleSelectWithSearchInput>
      </div>
    </div>
    <!-- 應徵職務 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>應徵職務</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <SimpleSelectWithSearchInput
          buttonPlaceholder="請選擇職務"
          buttonWidth="720px"
          modalWidth="720px"
          :options="['人資招募管理師', '工程師']"
          :selectedValue.sync="position"
        ></SimpleSelectWithSearchInput>
      </div>
    </div>
    <!-- 用人單位 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>用人單位</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="請選擇單位"
          buttonWidth="248px"
          modalWidth="248px"
          :options="['人力資源部', '企劃部']"
          :selectedValue.sync="unit"
        ></SimpleSelectWithSearchInput>
      </div>
    </div>
    <!-- 權責主管 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>權責主管</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 ">
        <v-radio-group row v-model="supervisorOfPower">
          <div v-for="item in ['Y', 'N']" :key="item" class="w-33">
            <v-radio class="mr-1" :value="item">
              <template v-slot:label>
                <div class="ink-01-emphasis--text">
                  {{ item }}
                </div>
              </template>
            </v-radio>
          </div>
        </v-radio-group>
      </div>
    </div>
    <!-- 用人主管 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>用人主管</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="請選擇主管"
          buttonWidth="248px"
          modalWidth="248px"
          :options="options.supervisorsOfUse"
          :selectedValue.sync="supervisorsOfUse"
        ></SimpleSelectWithSearchInput>
      </div>
    </div>
    <!-- 招募窗口 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>招募窗口</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="請選擇窗口"
          buttonWidth="248px"
          modalWidth="248px"
          :options="options.contactPerson"
          :selectedValue.sync="contactPerson"
        ></SimpleSelectWithSearchInput>
      </div>
    </div>
    <!-- 求職者姓名 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>求職者姓名</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <div class="form-input-group w-248px">
          <input type="text" v-model="name" />
        </div>
      </div>
    </div>
    <!-- 身份證字號 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>身份證字號</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <div class="form-input-group w-248px">
          <input type="text" v-model="identityCard" />
        </div>
      </div>
    </div>
    <!-- 聯絡電話 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>聯絡電話</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <div class="form-input-group w-248px">
          <input type="text" v-model="phone" />
        </div>
      </div>
    </div>
    <!-- 出生年 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>出生年</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <div class="form-input-group w-248px">
          <input type="text" v-model="yearOfBirth" />
        </div>
      </div>
    </div>
    <!-- 履歷連結 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>履歷連結</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 d-flex">
        <a :href="linkOfResume" class="text-decoration-none">履歷連結</a>
      </div>
    </div>
    <!-- 履歷來源 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>履歷來源</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="請選擇來源"
          buttonWidth="248px"
          modalWidth="248px"
          :options="options.resumeResource"
          :selectedValue.sync="resumeResource"
        ></SimpleSelectWithSearchInput>
        <div class="form-input-group flex-grow-1">
          <input
            type="text"
            :placeholder="
              `請輸入${resumeResource ? resumeResource : '來源'}代號`
            "
            v-model="resumeResourceCode"
          />
        </div>
      </div>
    </div>
    <!-- 面試主管 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>面試主管</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex resume-combobox">
        <v-combobox
          class="w-180px"
          placeholder="輸入名字後enter或勾選名字"
          v-model="supervisorsOfInterview"
          :items="['李英豪', '羅嘉仁']"
          multiple
          outlined
          dense
        >
        </v-combobox>
      </div>
    </div>
    <!-- 其他面試人員 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>其他面試人員</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex resume-combobox">
        <v-combobox
          class="w-180px"
          placeholder="輸入名字後enter或勾選名字"
          v-model="othersOfInterview"
          :items="['王阿榮', '章文明', '陳宏智']"
          multiple
          outlined
          dense
        >
        </v-combobox>
      </div>
    </div>
    <!-- 履歷表是否回收 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>履歷表是否回收</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 ">
        <v-radio-group row v-model="isResumeRecycled">
          <div v-for="item in ['Y', 'N']" :key="item" class="w-33">
            <v-radio class="mr-1" :value="item">
              <template v-slot:label>
                <div class="ink-01-emphasis--text">
                  {{ item }}
                </div>
              </template>
            </v-radio>
          </div>
        </v-radio-group>
      </div>
    </div>
    <!-- 面試結果 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>面試結果</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0">
        <v-radio-group row v-model="result">
          <div
            v-for="item in ['錄取', '未錄取', '黑名單']"
            :key="item"
            class="w-33"
          >
            <v-radio class="mr-1" :value="item">
              <template v-slot:label>
                <div class="ink-01-emphasis--text">
                  {{ item }}
                </div>
              </template>
            </v-radio>
          </div>
        </v-radio-group>
      </div>
    </div>
    <!-- 預計報到日期 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>預計報到日期</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="請選擇年份"
          buttonWidth="200px"
          modalWidth="200px"
          modalBodyHeight="200px"
          :options="options.year"
          :selectedValue.sync="yearOfCheckin"
        ></SimpleSelectWithSearchInput>
        <SimpleSelect
          class="mr-5"
          buttonPlaceholder="請選擇月份"
          buttonWidth="200px"
          modalWidth="200px"
          modalBodyHeight="200px"
          :options="options.month"
          :selectedValue.sync="monthOfCheckin"
        ></SimpleSelect>
        <SimpleSelect
          class="mr-5"
          buttonPlaceholder="請選擇日期"
          buttonWidth="200px"
          modalWidth="200px"
          modalBodyHeight="200px"
          :options="options.date"
          :selectedValue.sync="dateOfCheckin"
        ></SimpleSelect>
      </div>
    </div>
    <!-- 寄發感謝函日期 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>寄發感謝函日期</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="請選擇年份"
          buttonWidth="200px"
          modalWidth="200px"
          modalBodyHeight="180px"
          :options="options.year"
          :selectedValue.sync="yearOfSend3QLetter"
        ></SimpleSelectWithSearchInput>
        <SimpleSelect
          class="mr-5"
          buttonPlaceholder="請選擇月份"
          buttonWidth="200px"
          modalWidth="200px"
          modalBodyHeight="200px"
          :options="options.month"
          :selectedValue.sync="monthOfSend3QLetter"
        ></SimpleSelect>
        <SimpleSelect
          class="mr-5"
          buttonPlaceholder="請選擇日期"
          buttonWidth="200px"
          modalWidth="200px"
          modalBodyHeight="200px"
          :options="options.date"
          :selectedValue.sync="dateOfSend3QLetter"
        ></SimpleSelect>
      </div>
    </div>
    <!-- 備註/原因 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>備註/原因</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <div class="form-input-group w-100">
          <input type="text" v-model="remarks" />
        </div>
      </div>
    </div>
    <!-- 刪除求職者資料 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>刪除求職者資料</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <button class="btn btn-danger w-80px" @click="deleteHandler">
          刪除
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FileUploader from '@/components/FileUploader.vue';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import SimpleSelect from '@/components/Selection/SimpleSelect.vue';
import TimeSelector from '@/views/J__HR/c/TimeSelector.vue';

export default {
  components: {
    FileUploader,
    SimpleSelectWithSearchInput,
    SimpleSelect,
    TimeSelector,
  },
  data: () => ({
    dateOfWriteResume: '2020.08.08',
    fileOfUpload: '',
    // interview Time
    yearOfInterview: '',
    monthOfInterview: '',
    dateOfInterview: '',
    hourOfInterview: '',
    minuteOfIntervew: '',
    phrase: '',
    categoryOfPosition: '',
    position: '',
    unit: '',
    supervisorOfPower: 'Y',
    supervisorsOfUse: '',
    contactPerson: '',
    // 求職者資料
    name: '',
    identityCard: '',
    phone: '',
    yearOfBirth: '',
    linkOfResume: 'www.google.com.tw',
    // 履歷
    resumeResource: '',
    resumeResourceCode: '',
    // 面試人員
    supervisorsOfInterview: [],
    othersOfInterview: [],
    //
    isResumeRecycled: '',
    result: '',
    //
    yearOfCheckin: '',
    monthOfCheckin: '',
    dateOfCheckin: '',
    yearOfSend3QLetter: '',
    monthOfSend3QLetter: '',
    dateOfSend3QLetter: '',
    remarks: '',
    // options
    options: {
      year: [...Array(100).keys()].map((i) => `${i + 2001}`),
      month: [...Array(12).keys()].map((i) => `${i + 1}`),
      date: [...Array(31).keys()].map((i) => `${i + 1}`),
      supervisorsOfUse: ['李英豪', '蔡小虎', '王宜靜'],
      contactPerson: ['張庭絨', '汪大成'],
      resumeResource: ['104', '1111'],
    },
  }),
  methods: {
    deleteHandler() {
      this.$router.push('/human-resource');
    },
  },
};
</script>

<style lang="scss">
.resume-combobox {
  .v-combobox {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }

  .v-chip {
    background-color: #f7fafc !important;
    border: solid 1px #d7dee7;
  }

  .v-text-field__details {
    display: none;
  }
}
</style>
